(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["refyne-hero-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('refyne-hero-countdown')) {
    customElements.define('refyne-hero-countdown', class extends HTMLElement {
      connectedCallback() {
        clearInterval(this.interval);
        const tick = () => {
          const target = Date.parse(this.dataset.target);
          const seconds = Number.isFinite(target) ? Math.max(0, Math.floor((target - Date.now()) / 1000)) : 0;
          const values = {
            days: Math.floor(seconds / 86400),
            hours: Math.floor(seconds / 3600) % 24,
            minutes: Math.floor(seconds / 60) % 60,
            seconds: seconds % 60
          };
          for (const [unit, value] of Object.entries(values)) {
            const element = this.querySelector('[data-' + unit + ']');
            if (element) element.textContent = String(value).padStart(2, '0');
          }
          if (seconds === 0) clearInterval(this.interval);
          return seconds > 0;
        };
        if (tick()) this.interval = setInterval(tick, 1000);
      }
      disconnectedCallback() {
        clearInterval(this.interval);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
